/* @flow */

import type { RootState, CursoredUrlsStore } from '../types'
import { SET_SEARCH } from './ui/search'

export const INTO_CURSORED_URL_STORES: string =
  'opinary/INTO_CURSORED_URL_STORES'
export const CLEAR_CURSORS: string = 'opinary/CLEAR_CURSORS'

type CursoredUrlsAction = {
  type: string,
  payload?: {
    key: string,
    next: string,
  },
}

export function intoCursoredUrlsStore(
  key: string,
  next: string
): CursoredUrlsAction {
  return {
    type: INTO_CURSORED_URL_STORES,
    payload: {
      key,
      next,
    },
  }
}

export function clearCursors(): CursoredUrlsAction {
  return {
    type: CLEAR_CURSORS,
  }
}

export function getLibraryPollKey(rootState: RootState) {
  return 'polls'
}

export function hasMore(rootState: RootState, key: string) {
  return selectNextUrlForUrl(rootState, key)
}

export function selectNextUrlForUrl(
  rootState: RootState,
  key: string
): ?string {
  return rootState.cursoredUrlsStore[key]
}

export default function reducer(
  state: CursoredUrlsStore = {},
  action: CursoredUrlsAction
): CursoredUrlsStore {
  switch (action.type) {
    // eslint-disable-next-line no-case-declarations
    case INTO_CURSORED_URL_STORES:
      if (!action.payload) throw new Error('Missing payload for')
      return {
        ...state,
        [action.payload.key]: action.payload.next,
      }
    case SET_SEARCH:
    case CLEAR_CURSORS:
      return {}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/cursoredUrlsStore.js